import React from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import axios from "axios";
import { SignOutIcon } from "../../assets/icons/icons";
import { validateAvatar } from "../../utils/common";

const { UnoAppsPopover } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const HeaderMobile = () => {
  const appData = useUnoSelector((state) => state.application);
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);

  const handleLogout = async () => {
    try {
      await axios.post(
        `${configData.config.UNO_URL}/api/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );
      window.location.reload();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="header-mob">
      <div className="app-title">
        <img
          src={
            configData?.config?.logo
              ? configData?.config?.logo
              : "https://cdn.simulanis.io/sso/logos/default_simulanis.png"
          }
          referrerPolicy="no-referrer"
          alt="logo"
        />
        <span className="app-name">{configData?.config?.name}</span>
      </div>
      <div className="d-flex justify-content-center align-items-center gap-2">
        <div className="dropdown">
          <div className={`profile-info dropdown-toggle userIcon`} data-bs-toggle="dropdown" aria-expanded="false">
            {validateAvatar(userData?.user?.avatar, userData?.user?.name)}
          </div>
          <div className={`dropdown-menu profile-detail-parent p-0`}>
            <div className={`profile-detail`}>
              <div className="bg">{validateAvatar(userData?.user?.avatar, userData?.user?.name)}</div>
              <span className="name-email">
                <p>{userData?.user?.name}</p>
                <p className="email"> {userData?.user?.email}</p>
                <p className="designation"> {userData?.user?.designation}</p>
              </span>
              <span className="signout" onClick={handleLogout}>
                <SignOutIcon />
                Sign Out
              </span>
            </div>
          </div>
        </div>
        <UnoAppsPopover
          applications={appData?.apps || []}
          onAppClick={(e) => {
            if (e.origin) {
              window.location.href = e.origin;
            }
          }}
        />
      </div>
    </div>
  );
};

export default HeaderMobile;
